import { createFileRoute } from "@tanstack/react-router";

import ReviewList from "@/pages/review/ReviewList";

export const Route = createFileRoute("/review/")({
  component: ReviewList,
});
